module.exports = __webpack_public_path__ + "img/lock-keyhole-square.d235513b.svg";